import React from 'react';
import { connect } from 'react-redux';
import findResult, { hasMinimumLength } from '@/utils/resultsHelper';
import UserFieldListItem from '../components/UserFieldListItem';
import UserFieldHeader from '../components/UserFieldHeader';

const UserSummary = ({
  archivedReason,
  email,
  name,
  roleName,
}) => (
  <>
    <UserFieldHeader value={name} icon="user" />
    <UserFieldListItem value={roleName} type="role" />
    <UserFieldListItem value={email} type="email" />
    {hasMinimumLength(archivedReason) && (<UserFieldListItem markdown value={archivedReason} type="archived" />)}
  </>
);

const mapStateToProps = ({
  auth: { users },
}, { category, code }) => {
  const defaultUser = {
    role: { name: '' },
    email: '',
    name: '',
    archived: false,
    archived_reason: '',
  };
  const item = findResult(users, category, code) || defaultUser;
  const role = item.role || defaultUser.role;

  return (
    {
      archivedReason: item.archived ? item.archived_reason : '',
      email: item.email,
      name: item.name,
      roleName: role.name,
    }
  );
};

export default connect(mapStateToProps)(UserSummary);
